export default "__VITE_ASSET__CsWlDuVJ__"